import React, { useState } from 'react';

import './LoginPage.css';

import { useDispatch } from 'react-redux'
import { login } from '../redux/reducers'

import { useSelector } from 'react-redux'
import { useEffect } from 'react';

import { useHistory } from "react-router-dom";
import Icon from '../compUtils/Icon';

function LoginPage(props) {

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const dispatch = useDispatch()

  const loginState = useSelector(store => store.loginReducer)

  const history = useHistory();


  const tryLogin = () => {
    dispatch(login({"username": username,"password": password}))
  }

  useEffect(()=>{
    if (loginState.loginStatus==="logged")
      {
        history.push("/profiles/"+loginState.profile.id)
      }
  },[loginState.loginStatus])

  return (

    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">

          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div class="box">
                {loginState.loginStatus==="fail" ?<span class="fail">ALIEN</span>:""}
                <div class="field">
                  <label  class="label">Email</label>
                  <div class="control has-icons-left">
                    <input type="email" placeholder="e.g. bobsmith@gmail.com" class="input"  onChange={event => setUsername(event.target.value)} required />
                    <span class="icon is-small is-left">
                      <Icon name="envelope" />
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label  class="label">Password</label>
                  <div class="control has-icons-left">
                    <input type="password" placeholder="*******" class="input" onChange={event => setPassword(event.target.value)} required />
                    <span class="icon is-small is-left">
                      <Icon name="lock" />
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label  class="checkbox">
                    <input type="checkbox" />
                    {" "}Remember me
              </label>
                </div>
                <div class="field">
                  <button class="button is-success" onClick={tryLogin} >
                    Login
              </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

  );
}

export default LoginPage;
